import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo)
  }

  handleReload = () => {
    window.location.href = '/'
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0a0e17] flex items-center justify-center px-4">
          <div className="card max-w-md w-full text-center space-y-6">
            <div className="w-16 h-16 bg-red-500/15 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>

            <div>
              <h2
                className="text-xl font-bold text-white mb-2"
                style={{ fontFamily: "'Orbitron', sans-serif" }}
              >
                Something went wrong
              </h2>
              <p className="text-gray-400 text-sm">
                An unexpected error occurred. Please try reloading the page.
              </p>
            </div>

            {this.state.error && (
              <div className="bg-red-500/5 border border-red-500/20 rounded-lg p-3">
                <p className="text-red-400/70 text-xs font-mono break-all">
                  {this.state.error.message}
                </p>
              </div>
            )}

            <button onClick={this.handleReload} className="btn-primary w-full">
              Reload Page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
